module.exports = __webpack_public_path__ + "img/downChevron.75ff826f.svg";